<div class="tab " #container>
  <i *ngIf="showLeftChevron"
     class="fal fa-chevron-left tab-scroll-arrow tab-scroll-arrow-left"
     (click)="scrollTabs(-1)"></i>

  <div class="tab-header-container"
       #headercontainerwrapper
       (wheel)="onWheel($event)"
       [style.margin-left]="showLeftChevron ? '1.5rem' : '0'"
       [style.width]="'calc(100% - ' + ((showLeftChevron ? 1.5 : 0) + (showRightChevron ? 1.5 : 0)) + 'rem)'">
    <div class="tab-header" [style]="style" #headercontainer>
      <button  #xyz *ngFor="let item of header;index as i"
               class="tab-page"
               (click)="onTabClick(i,xyz)"
               [disabled]="item.disabled"
               [hidden]="item.hidden"
      >
        <i *ngIf="item.icon_class && item.icon_class.length>0" [class]="item.icon_class"></i>{{item.caption}}
        <span class="tab-marker" *ngIf="i==selectedtab"></span>
      </button>
    </div>
  </div>

  <i *ngIf="showRightChevron"
     class="fal fa-chevron-right tab-scroll-arrow tab-scroll-arrow-right"
     (click)="scrollTabs(1)"></i>

  <div class="tab-content" [style]="contentstyle">
    <ng-container *ngTemplateOutlet="pages"></ng-container>
  </div>
</div>
